module.exports = __webpack_public_path__ + "media/images/revenue_share_mindtree-d65a52bb9e6e7ed40e2faa33de56fb4b.png";